import { CircularProgress } from '@material-ui/core';
import React from 'react';

type Props = {
  size?: number | string;
};

export function Loader(props: Props): React.ReactElement {
  const { size } = props;
  return <CircularProgress size={size} />;
}
